import { Button } from '@/components/Button';
import { CircleCheckIcon } from '@/components/Icons';

import { StyledAction, StyledIconAndText } from './styles';

interface ExcursionBookingFormButtonProps {
  onClick: () => void;
  isItineraryProductSelected: boolean;
}

export function ExcursionBookingFormButton({ onClick, isItineraryProductSelected }: ExcursionBookingFormButtonProps) {
  return (
    <StyledAction>
      {isItineraryProductSelected && (
        <Button variant="secondaryBright" onClick={() => {}}>
          <StyledIconAndText>
            <CircleCheckIcon size="lg" /> Included
          </StyledIconAndText>
        </Button>
      )}
      {!isItineraryProductSelected && (
        <Button variant="tertiary" onClick={onClick}>
          Book activity
        </Button>
      )}
    </StyledAction>
  );
}
